import { createReducer, on } from '@ngrx/store';
import { setExpenseEntryGridConfig, clearExpenseEntryGridConfig } from './expenseEntryGridConfig.actions';
import { initialExpenseEntryGridConfigModel } from './expenseEntryGridConfig.state';

export const expenseEntryGridConfigReducer = createReducer(
    initialExpenseEntryGridConfigModel ,
    on(setExpenseEntryGridConfig, (state, { expenseEntryGridConfig }) => ({ ...state, expenseEntryGridConfig : expenseEntryGridConfig })),
    on(clearExpenseEntryGridConfig, state => ({ ...state, expenseEntryGridConfig : null }))
);